<script setup lang="ts">
import TreasuryAccountsContainer from './containers/TreasuryAccountsContainer.vue'
</script>

<template>
  <TreasuryAccountsContainer />
</template>
